/*
Locks

  --mount <string::enum> | ['Horizontal', 'Vertical']
  --setBack <float> | inches
  --throwDistance <float> | inches
  --materialThickness <float> | inches | default: 3/4"

*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Locks'
const id = '4BIP9fWanXkrUDf72duM'

export default {
  name,
  id,
  filters,
  headers,
  form
}
